import React from 'react';
import PropTypes from 'prop-types';
import { IntlShape } from 'react-intl';
import RelationSearch from '@/shared/components/input/RelationSearch';
import RelationName from '@/shared/components/RelationName';
import FormGroupPart from './FormGroupPart';
import { relationShape } from '../registrationHelpers';
import messages from '../registrationMessages';

const RelationFormGroup = ({
  relation,
  onChange,
  readOnly,
  disabled,
  showValidation,
  autoFocus,
  crmTypes,
}) => (
  <div className="form-group">
    <FormGroupPart
      label={messages.Relation}
      inputCols="col-sm-10"
      invalid={showValidation && !readOnly && (!relation || !relation.id)}
    >
      {readOnly ? (
        <p className="form-control-static">
          {relation && <RelationName relation={relation} enabled={false} />}
        </p>
      ) : (
        <RelationSearch
          onChange={onChange}
          initialSelectedItem={relation}
          autoFocus={typeof autoFocus === 'undefined' ? !relation : autoFocus}
          disabled={disabled}
          crmTypes={crmTypes}
          small
        />
      )}
    </FormGroupPart>
  </div>
);
RelationFormGroup.propTypes = {
  relation: relationShape,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  showValidation: PropTypes.bool,
  autoFocus: PropTypes.bool,
  crmTypes: PropTypes.arrayOf(PropTypes.number),
};
RelationFormGroup.defaultProps = {
  relation: null,
  onChange: () => {},
  readOnly: false,
  disabled: false,
  showValidation: false,
  autoFocus: undefined,
  crmTypes: [],
};
export default RelationFormGroup;
